/**
 * @format
 * @Description: 已发消息状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './MessageDetailServ';
import { message } from 'antd';
import { get, isArray, map } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class MessageDetailMod {
  @observable
  form = '';

  @observable
  originFormData = {};

  @observable
  defaultCheckbox = [];

  @observable
  eventId = '';

  @observable
  tabsVal = '3';

  @observable
  showModalChooseTemplate = false;

  @observable
  showModalAddParam = false;

  @observable
  showModalJumpPage = false;

  @observable
  modalType = '';

  @observable
  channelObj = {
  };

  MessageTypeEnum = {
    SMS: '1',
    EMAIL: '2',
    INMAIL: '3',
    WECHAT: '4',
    APP: '5'
  };

  @observable
  isRelevanceTemplate = '0';
  //当前消息类型下是自定义还是绑定模板

  @observable
  targetChannels = '';

  @observable
  tabsData = '';

  attributeDto = {};

  @observable
  attributeDtoList = [];

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }
  @action addOrganization = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.addOrganization(params);
  };

  @action getListMessageChannel = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getListMessageChannel(params);
  };
  @action getListMessageType = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getListMessageType(params);
  };

  tabsChange = data => {
    this.updateStore({ tabsVal: data });
    this.tabsChangeAfter();
    this.updateStore({ channelObj: {} });
    this.getChannel();
    this.updateStore({ formVersion: Math.random() });
  };
  getChannel = data => {
    let params = {
      pageNum: 1,
      pageSize: 1000
    };

    this.getListMessageChannel(params)
      .then(res => {
        let channelObj = {
        };
        map(get(res, 'data.list'), item => {
          if (channelObj[item.channelType]) {
            channelObj[item.channelType].push({ value: item.id, label: item.vender });
          } else {
            channelObj[item.channelType] = [{ value: item.id, label: item.vender }]
          }
        });
        this.updateStore({ channelObj: channelObj });
      })
      .catch(err => {
      });
  };
  tabsChangeAfter = () => {
    this.updateStore({ originFormData: {}, targetChannels: '', isRelevanceTemplate: '0' });
    let obj = {
      channelId: [],
      code: '',
      name: '',
      title: '',
      content: '',
      providerTplCode: '',
      jumpUrl: '',
      template: '0'
    };
    this.form.setFieldsValue(obj);
    this.getEventById({ id: this.eventId })
      .then(res => {
        let list = get(res, 'data.messageTemplateRespDtoList');
        map(list, item => {
          if (item.msgType == this.tabsVal) {
            let obj = {
              channelId: [],
              code: '',
              name: '',
              title: '',
              content: '',
              providerTplCode: '',
              jumpUrl: ''
            };
            obj.template = '1';
            for (let i in item) {
              obj[i] = item[i];
            }
            if (this.tabsVal == this.MessageTypeEnum.INMAIL) {
              obj.channelId = res.data.targetChannel;
            }

            this.changeTargetChannels(obj.channelId);
            this.form.setFieldsValue(obj);
            this.updateStore({ originFormData: item, isRelevanceTemplate: '1' });
          }
        });
      })
      .catch(err => {
      });
  };
  beforeGetTemplateList(data) {
    return data;
  }
  afterGetTemplateList = data => {
    // let template_code = get(this.eventChannel,this.eventId+'.2.0.template_code')
    let obj = {};
    map(get(data, 'list'), item => {
      if (item.code == this.template_code) {
        obj = item;
        this.updateStore({ template: obj });
      }
    });
    return obj;
  };
  afterGetTemplateList2 = data => {
    let eventTemplate = this.eventTemplate[this.eventId];
    map(get(data, 'list'), item => {
      item.isRelevance = 0;
      map(eventTemplate, item1 => {
        if (item.code == item1.templateCode) {
          item.isRelevance = 1;
        }
      });
    });
    return data;
  };
  getParamListAfterRequest = data => {
    map(data, (item, index) => {
      item.key = index;
    });
    let obj = {};
    obj.list = data;
    return obj;
  };

  addParamToContent = data => {
    let key = this.modalType;
    let val = this.form.getFieldValue(key) ? this.form.getFieldValue(key) : '';
    let obj = {};
    obj[key] = val + '{' + data.code + '}';
    this.form.setFieldsValue(obj);
    this.updateStore({ showModalAddParam: false });
  };

  saveFormBeforeRequest = data => {
    if (data.template == 1) {
      delete data.template;
      return data;
    } else {
      data.msgType = this.tabsVal;
      delete data.channelId;
      delete data.template;
      delete data.eventId;
      return data;
    }
  };
  saveFormAfterRequest = data => {
    message.success('事件绑定模板成功');
  };
  openModalChooseTemplate = data => {
    this.updateStore({ showModalChooseTemplate: true, defaultCheckbox: [this.originFormData.id] });
  };
  templateRadioChange = data => {
    this.updateStore({ isRelevanceTemplate: data });
    let obj = {
      code: '',
      name: '',
      title: '',
      content: '',
      providerTplCode: '',
      jumpUrl: ''
    };
    this.form.setFieldsValue(obj);
    if (data == 1) {
      for (let i in obj) {
        obj[i] = this.originFormData[i];
      }
      this.form.setFieldsValue(obj);
    }
  };
  openModalAddParam = type => {
    this.updateStore({ showModalAddParam: true, modalType: type });
  };
  openModalJumpPage = () => {
    this.updateStore({ showModalJumpPage: true });
  };
  getTemplateListAfterRequest = data => {
    return data;
  };
  getTemplateListBeforeRequest = data => {
    data.filter = {
      msgType: this.tabsVal || undefined,
      code: data.code || undefined,
      name: data.name || undefined
    };
    return data;
  };
  chooseTemplate = data => {
    if (get(data, 'keys.length') == 0) {
      message.warn('请选择一个模板');
    } else if (get(data, 'keys.length') > 1) {
      message.warn('只能选择一个模板');
    } else if (get(data, 'keys.length') == 1) {
      let originFormData = get(data, 'rows.0');
      let obj = {
        code: '',
        name: '',
        title: '',
        content: '',
        providerTplCode: '',
        jumpUrl: ''
      };
      this.form.setFieldsValue(obj);
      for (let i in obj) {
        obj[i] = originFormData[i];
      }
      this.updateStore({ originFormData: originFormData, showModalChooseTemplate: false });
      this.form.setFieldsValue(obj);
      message.success('已选择模板，请选择渠道后点击保存绑定该模板');
    }
  };
  @action getEventById = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getEventById(params);
  };
  changeTargetChannels = (data) => {
    let str = '';
    if (isArray(data)) {
      map(data, (item, index) => {
        if (index == 0) {
          str = String(item);
        } else {
          str = str + ',' + String(item);
        }
      });
    } else {
      str = data;
    }

    this.updateStore({ targetChannels: str });
  };
}

// ES6单例写法
export default new MessageDetailMod();



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MessageDetail/MessageDetailMod.js